import { Axios } from './../shared/Axios';
import qs from 'qs';
import { saveAs } from "file-saver";
import moment from 'moment';

class PaymentService extends Axios {

    private static instance: PaymentService;

    static get(): PaymentService {
        if (!PaymentService.instance) {
            PaymentService.instance = new PaymentService();
        }
        return PaymentService.instance;
    }

    async getPaymentTransactions(data: object): Promise<any> {

        return this.instance.get(`/admin/payment/transactions${qs.stringify(data, { addQueryPrefix: true })}`)
    }

    async exportPaymentTransactions(data: object): Promise<any> {

        const response : any = await this.instance.get(`/admin/payment/transactions/export${qs.stringify(data, { addQueryPrefix: true })}`, {
            responseType: "arraybuffer"
        })
        // Create a Blob from the response data
        const blob = new Blob([response], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        // Save the file using FileSaver
        saveAs(blob, `Report_${moment().format('DD-MM-YYYY_HH:mm')}.xlsx`);

        return response;


    }

    async getPaymentTransactions2(data: object): Promise<any> {

        return this.instance.get(`/admin/payment/transactions2${qs.stringify(data, { addQueryPrefix: true })}`)
    }

    async exportPaymentTransactions2(data: object): Promise<any> {

        const response : any = await this.instance.get(`/admin/payment/transactions2/export${qs.stringify(data, { addQueryPrefix: true })}`, {
            responseType: "arraybuffer"
        })
        // Create a Blob from the response data
        const blob = new Blob([response], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        // Save the file using FileSaver
        saveAs(blob, `Report_${moment().format('DD-MM-YYYY_HH:mm')}.xlsx`);

        return response;


    }




}


const paymentService = PaymentService.get();

export { paymentService as PaymentService }